import { defaultRoutesDrawerMapModeFilterMetric } from '~/reducers/routesDrawerFilterSlice';
import { defaultRoutesDrawerMapModeSortMetric } from '~/reducers/routesDrawerSortSlice';

/**
 * NOVA-1100
 *
 * restructure `routesDrawerFilter` and `routesDrawerSort`
 */
export default function (state) {
    return {
        ...state,
        routesDrawerFilter: {
            plan: defaultRoutesDrawerMapModeFilterMetric,
            dispatched: defaultRoutesDrawerMapModeFilterMetric,
            completed: defaultRoutesDrawerMapModeFilterMetric
        },
        routesDrawerSort: {
            plan: defaultRoutesDrawerMapModeSortMetric,
            dispatched: defaultRoutesDrawerMapModeSortMetric,
            completed: defaultRoutesDrawerMapModeSortMetric
        }
    };
}
